// extracted by mini-css-extract-plugin
export var danger = "_2c-6";
export var lightPink = "_2c-a";
export var medium = "_2c-j";
export var nearSquare = "_2c-m";
export var neutralBlue = "_2c-8";
export var neutralYellow = "_2c-7";
export var noCapitalize = "_2c-1";
export var normal = "_2c-2";
export var pill = "_2c-0";
export var primary = "_2c-3";
export var primaryLight = "_2c-4";
export var shadow = "_2c-n";
export var small = "_2c-k";
export var solidBlack = "_2c-i";
export var solidGreen = "_2c-d";
export var solidLightBlue = "_2c-f";
export var solidNavy = "_2c-e";
export var solidOrange = "_2c-h";
export var solidPink = "_2c-g";
export var solidRed = "_2c-b";
export var solidWhite = "_2c-9";
export var solidYellow = "_2c-c";
export var success = "_2c-5";
export var xsmall = "_2c-l";